import { Typography, styled } from '@mui/material';

export const StyledTitle = styled(Typography)(({ theme }) => ({
  fontSize: theme.typography.textXl.fontSize,
  fontWeight: '700',
  color: theme.palette.title.main,
}));
